import { render, staticRenderFns } from "./WarningTriangle.vue?vue&type=template&id=fed0e096&"
import script from "./WarningTriangle.vue?vue&type=script&setup=true&lang=js&"
export * from "./WarningTriangle.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports